import React from 'react';
import { ArrowRight } from 'lucide-react';

export const MusicInGentofteBanner = () => {
  return (
    <div className="px-4 pt-20 md:px-6">
      <div className="mx-auto flex w-full max-w-6xl items-center justify-between gap-4 rounded-2xl border border-[#8dd7ea]/70 bg-gradient-to-r from-[#c8f3ff] via-[#d8f8ff] to-[#e7fffb] px-4 py-3 shadow-[0_16px_40px_rgba(77,140,153,0.18)]">
        <a
          href="https://www.musikigentofte.dk/#sponsors"
          target="_blank"
          rel="noopener noreferrer"
          className="flex min-w-0 items-center gap-3 text-sm font-semibold text-[#1c5b63] transition-opacity hover:opacity-85 md:gap-4 md:text-base"
        >
          <img
            src="/mig-logo.png"
            alt="Musik i Gentofte"
            className="h-10 w-auto flex-shrink-0 rounded-md bg-white/35 p-1 md:h-12"
          />
          <span className="truncate">Se vores løsning på Musik i Gentofte</span>
          <ArrowRight className="h-4 w-4 flex-shrink-0" />
        </a>
      </div>
    </div>
  );
};
